const data = {
  "newsletter": {
    "question": "Heb je een vraag?",
    "answer": "Vind je antwoord snel en makkelijk op <csLink>onze klantenservice pagina</csLink>.",
    "signup": "Meld je aan voor onze nieuwsbrief",
    "receive": "Ontvang de beste aanbiedingen en persoonlijk advies.",
    "specialistImage": "Product specialist bij Coolblue"
  },
  "newsletterForm": {
    "emailField": "E-mailadres",
    "submit": "Aanmelden",
    "emailEmpty": "Er is geen e-mailadres ingevuld.",
    "emailInvalid": "Er is geen geldig e-mailadres ingevuld. Controleer of het e-mailadres een @ en een punt bevat. En of er geen spaties in staan.",
    "subscriptionSucceededTitle": "Je bent ingeschreven",
    "subscriptionSucceededMessage": "Je ontvangt binnen enkele minuten een e-mail op {{email}}. Hierin vind je een link om je inschrijving mee te bevestigen.",
    "subscriptionFailedMessage": "Er is iets mis gegaan bij het inschrijven."
  },
  "coolblueFooter": {
    "customerService": {
      "title": "Klantenservice",
      "deliverAndInstallation": "Bezorgen en installeren",
      "payment": "Betalen",
      "exchangeAndReturn": "Ruilen en retourneren",
      "warrantyRepairAndInsurance": "Garantie, reparatie en verzekeringen",
      "ordering": "Bestellen",
      "stores": "Winkels",
      "orderStatus": "Status van mijn bestelling",
      "returnOrRepair": "Retour of reparatie aanmelden",
      "allOrdersAndInvoices": "Al mijn bestellingen en facturen",
      "myCoolblue": "Mijn Coolblue-account",
      "contact": "Contact",
      "login": "Inloggen",
      "logout": "Uitloggen",
      "about": "Naar de klantenservice"
    },
    "corporate": {
      "title": "Zakelijk",
      "order": "Zakelijk bestellen",
      "giftCards": "Zakelijke cadeaubonnen",
      "christmasGifts": "Kerstgeschenken",
      "companyStores": "Bedrijfswinkels",
      "homeOfficeStore": "Thuiswerkwinkel",
      "digisprong": "Digisprong",
      "bringYourOwnDevice": "Bring Your Own Device",
      "giftStore": "Cadeauwinkel",
      "affiliateProgram": "Affiliate programma",
      "about": "Alles over zakelijk",
      "business": "Zakelijk"
    },
    "stores": {
      "title": "Onze winkels",
      "viewAllOurStores": "Bekijk al onze {{count}} winkels",
      "viewAllStores": "Bekijk al onze winkels",
      "new": "Nieuw"
    },
    "coolblue": {
      "title": "Over Coolblue",
      "assortment": "Ons assortiment",
      "companySite": "Bedrijfswebsite",
      "news": "Nieuws",
      "giftCards": "Cadeaubonnen",
      "careersAtCoolblue": "Werken bij Coolblue",
      "careersCallToAction": "Vacatures genoeg!",
      "devJobs": "Development jobs",
      "app": "De Coolblue-App",
      "belgium": "Coolblue België",
      "germany": "Coolblue Duitsland",
      "netherlands": "Coolblue Nederland",
      "privacy": "Privacy",
      "accessibilityStatement": "Toegankelijkheidsverklaring",
      "about": "Alles over Coolblue"
    },
    "bottomList": {
      "terms": "Algemene voorwaarden",
      "privacy": "Privacy",
      "cookies": "Cookies",
      "english": "English (EN)",
      "dutch": "Nederlands (NL)",
      "impressum": "Impressum",
      "about": "Over ons bedrijf"
    }
  },
  "trustLogos": {
    "ideal": "Betalen met iDeal",
    "banContact": "Betalen met Bancontact",
    "klarna": "Betalen met Klarna",
    "clickToPay": "Betalen met MasterCard en Visa via ClickToPay",
    "masterCard": "Betalen met MasterCard",
    "visa": "Betalen met Visa",
    "applePay": "Betalen met ApplePay",
    "payPal": "Betalen met PayPal",
    "ecoCheques": "Betalen met Ecocheques",
    "vorkasse": "Betalen met Vorkasse",
    "becom": "Webshop Trustmark en klantreviews",
    "safeShopsCertificate": "Safeshops.be certificaat informatie",
    "bestBrand": "<accent>Best</accent> Retail Hi-Fi Electro Brand 2024",
    "postNL": "Verzending en bezorging met PostNL",
    "bPost": "Verzending en bezorging met bPost",
    "dhl": "Verzending en bezorging met DHL",
    "tweakers": "<accent>Beste</accent> webwinkel 2022",
    "safeShops": "<accent>Klantvriendelijkste</accent> webshop 2020",
    "thuiswinkelWaarborg": "Thuiswinkel waarborg",
    "thuiswinkelZakelijk": "Thuiswinkel waarborg zakelijk",
    "emota": "Trustprofile van Coolblue"
  },
  "slogan": {
    "text": "alles voor een glimlach"
  }
};

export default data;